import { Tag as BaseTag } from 'baseui/tag';
export { KIND as TagKIND, VARIANT as TagVARIANT } from 'baseui/tag';

type ITagProps = any;
export const Tag = (props: ITagProps) => {
  return <BaseTag {...props} />;
};
